/* eslint-disable import/no-cycle */
import { numberWithCommas } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import moment from 'moment';

import { ALL } from '../constants';
import { getAppConfig } from '.';
import { BRAZIL } from './constants';

const formatDateForUi = (...date) => {
  let modifieddate = date;
  if (modifieddate.includes('') || modifieddate.includes(null)) return '';
  const dateFormat = 'DD-MMM-YYYY';
  modifieddate = modifieddate.slice(0, 3).reduce((con, item) => con + (con ? `-${item}` : item), '');
  return moment(modifieddate).format(dateFormat);
};

const formatDateForAPI = (...date) => {
  let modifieddate = date;
  if (modifieddate.includes('') || modifieddate.includes(null)) return '';
  const dateFormat = 'YYYY-MM-DD';
  modifieddate = modifieddate.slice(0, 3).reduce((con, item) => con + (con ? `-${item}` : item), '');
  return moment(modifieddate).format(dateFormat);
};

const generateTimeRangeWithInterval = (startTime, endTime, interval, amPm = false) => {
  const x = interval; // minutes interval
  const times = []; // time array
  let tt = startTime; // start time
  const et = endTime; // end time
  const ap = ['AM', 'PM']; // AM-PM

  // loop to increment the time and push results in array
  let i = 0;
  while (tt < et * 60) {
    const hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
    const mm = tt % 60; // getting minutes of the hour in 0-55 format
    const suffix = amPm ? ap[Math.floor(hh / 12)] : ''; // Am PM suffix condition
    const mode = amPm ? 12 : 24; // Am PM mode calculation
    let hr = `${`0${hh % mode}`.slice(-2)}`;
    if (suffix === 'PM' && hh === 12) {
      hr = '12'; // to accomodate 12:00PM instead of 00:00PM
    }
    const hhValue = `${`0${hh}`.slice(-2)}`;
    const mmValue = `${`0${mm}`.slice(-2)}`;
    const value = `${hr}:${`0${mm}`.slice(-2)} ${suffix}`.trim();
    times[i] = { label: value, value: `${hhValue}:${mmValue}:00.000Z` }; // pushing data in array in [00:00 - 12:00 AM/PM format]
    tt += x;
    i += 1;
  }
  return times;
};

const convertToDecimalPlaces = (num, decimalPlaces = 2) =>
  (Math.round(num * 10 ** decimalPlaces) / 10 ** decimalPlaces).toFixed(decimalPlaces);

const convertToDecimalWithCommas = (num, decimalPlaces = 2) =>
  numberWithCommas(convertToDecimalPlaces(num, decimalPlaces));

// displays numbers coma separator and decimals that are not 0
const convertToOptionalDecimalWithComas = (num, decimalPlaces = 2) =>
  numberWithCommas(num % 1 !== 0 ? convertToDecimalPlaces(num, decimalPlaces) : num);

const formatAnalyticsField = (initialValue, fieldArray, key) =>
  `${!initialValue ? '' : `${initialValue}|`}${fieldArray.find(attr => attr.key === key).value}`;

// sorts the array of objects based on the latest creation date
const timeStampBasedSort = (data = []) =>
  data && data.length ? data.slice().sort((a, b) => new Date(b.creationDate) - new Date(a.creationDate)) : data;

const shouldTheWholeNumberHavePeriodOrCommas = val => {
  const { country, lang } = getAppConfig('locale');
  if (`${country.toLowerCase()}/${lang}`.includes(BRAZIL) && val) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  return numberWithCommas(val);
};

const handleNumberFormatting = (numberToBeFormated, urlSet, decimalLimit) => {
  const [wholeNumber, fractionalValue] = numberToBeFormated.toString().split('.');
  const commaOrFullStop = urlSet.includes(BRAZIL) ? ',' : '.';
  const decimalValues = fractionalValue.substr(0, decimalLimit);
  return `${shouldTheWholeNumberHavePeriodOrCommas(wholeNumber)}${commaOrFullStop}${decimalValues}`;
};

const formatNumberBasedOnTheLocale = (numberToBeFormated, decimalLimit = 2) => {
  const { country, lang } = getAppConfig('locale');
  const languageSet = `${country.toLowerCase()}/${lang}`;
  const includesDot = numberToBeFormated.includes('.');
  if ((includesDot && languageSet.includes(BRAZIL)) || includesDot) {
    return handleNumberFormatting(numberToBeFormated, languageSet, decimalLimit);
  }
  return `${shouldTheWholeNumberHavePeriodOrCommas(numberToBeFormated)}`;
};

// converts coma and semicolon into white space
const replaceString = (string = '') => {
  if (string.length) {
    const includesComma = string.includes(',');
    const includesSemiColon = string.includes(';');
    if (includesComma || includesSemiColon) {
      const includesBothComaAndSemicolon = includesComma && includesSemiColon;
      const includesEither = () => (includesComma ? string.replace(/,/g, ' ') : string.replace(/;/g, ' '));
      return includesBothComaAndSemicolon ? string.replace(/,/g, ' ').replace(/;/g, ' ') : includesEither();
    }
  }
  return string;
};

const replaceValueInString = (splitAt, replaceWith, value = '') => value.split(splitAt).join(replaceWith);

const includeAllAsAnOption = (label, options, isSeperatedByPipe = false) => {
  if (options.length <= 1) {
    return options;
  }
  const allLabels = {
    name: label,
    value: ALL,
    label: <div className="option-header">{isSeperatedByPipe ? `${label} | ${label}` : `${label}`}</div>,
    ...(isSeperatedByPipe && { id: label })
  };
  return [{ ...allLabels }, ...options];
};

export {
  convertToDecimalPlaces,
  convertToDecimalWithCommas,
  convertToOptionalDecimalWithComas,
  formatAnalyticsField,
  formatDateForAPI,
  formatDateForUi,
  formatNumberBasedOnTheLocale,
  generateTimeRangeWithInterval,
  includeAllAsAnOption,
  replaceString,
  replaceValueInString,
  shouldTheWholeNumberHavePeriodOrCommas,
  timeStampBasedSort
};
